import { brandColors } from "../theme";

type Props = {
  size?: number;
  className?: string;
};

/** VideoDoktor mascot — purple brand theme (#9c5ebf). */
export const BrandLogo = ({ size = 40, className }: Props) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 100 100"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="VideoDoktor"
  >
    <circle cx="50" cy="50" r="48" fill="#fff" stroke={brandColors.purpleBorder} strokeWidth="2" />
    <circle cx="36" cy="50" r="40" fill={brandColors.purpleLight} />
    <circle cx="58" cy="50" r="40" fill={brandColors.purple} />
    <circle cx="66" cy="41" r="4.5" fill="#fff" />
    <circle cx="78" cy="41" r="4.5" fill="#fff" />
    <path
      d="M64 58 Q72 66 82 58"
      stroke="#fff"
      strokeWidth="3.5"
      fill="none"
      strokeLinecap="round"
    />
  </svg>
);
